import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = '/api';
const SiteSettingsContext = createContext({ settings: {}, refreshSettings: () => {} });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(() => {
    axios.get(`${API}/settings`).then(r => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  useEffect(() => { loadSettings(); }, [loadSettings]);

  return (
    <SiteSettingsContext.Provider value={{ settings: settings || {}, refreshSettings: loadSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext).settings;
}

export function useRefreshSettings() {
  return useContext(SiteSettingsContext).refreshSettings;
}
